module.exports = __webpack_public_path__ + "img/right_arrow_yellow_border.b2603200.svg";